import { useAiWebSocket as useWebSocketContext } from './AiWebSocketContext';

export const useAiWebSocket = () => useWebSocketContext();
